import { getAgentById } from '../../../api/agents/useFetchAgent'
import { getUserAgents } from '../../../api/agents/useFetchAgentsList'

const getAgentIds = (agents: any): string[] => Object.values(agents).map((type: any) => type.id)

export const fetchProviderAgents = (agents: any[]) => {
	const ids = getAgentIds(agents)
	const requests = ids.map(async (id) => await getAgentById(id))
	return Promise.allSettled(requests)
}

export const fetchCustomAgents = async ({ userId }: { userId: string }) => {
	const userCustomAgents = await getUserAgents({ userId, limit: 1000 })
	return userCustomAgents
}
